import React, { useState, useEffect } from 'react';
import { Link } from '@routes';
import IconAgent from '@icons/Agent';
import IconOfficeLocation from '@icons/OfficeLocation';
import * as G from '@styles/MobileNav.styled';
import IconAppraisal from '@icons/Appraisal';
import IconAccount from '@icons/Account';
import { getCookie } from '@cookies';

const FORM_FIELD_SELECTOR =
  'input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), textarea, select, [contenteditable="true"]';

const isFormField = (element) =>
  element?.matches?.(FORM_FIELD_SELECTOR);

const NavItem = ({ href, icon, children, active = false }) => {


  const content = (
    <G.MobileNavItem active={active}>
      {icon}
      {children}
    </G.MobileNavItem>
  );

  return <Link route={href} passHref>{content}</Link>;
};

const MobileNavbar = ({ currentPath = null, hideWhenFormFocused = false }) => {
  const token = getCookie('token');
  const [scrolled, setScrolled] = useState(false);
  const [formFocused, setFormFocused] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (!hideWhenFormFocused) return undefined;

    const handleFocusIn = (event) => {
      if (isFormField(event.target)) {
        setFormFocused(true);
      }
    };

    const handleFocusOut = () => {
      requestAnimationFrame(() => {
        if (!isFormField(document.activeElement)) {
          setFormFocused(false);
        }
      });
    };

    document.addEventListener('focusin', handleFocusIn);
    document.addEventListener('focusout', handleFocusOut);

    return () => {
      document.removeEventListener('focusin', handleFocusIn);
      document.removeEventListener('focusout', handleFocusOut);
    };
  }, [hideWhenFormFocused]);

  const isVisible = scrolled && !(hideWhenFormFocused && formFocused);

  return (
    <G.MobileNav justifyBetween scrolled={isVisible}>
      <NavItem href='/real-estate-agents' icon={<IconAgent />} active={currentPath && currentPath === 'real-estate-agents'}>Agents</NavItem>
      <NavItem href='/offices' icon={<IconOfficeLocation />} active={currentPath && currentPath === 'offices'}>Locations</NavItem>
      <NavItem href='/request-an-appraisal' icon={<IconAppraisal />} active={currentPath && currentPath === 'request-an-appraisal'}>Appraisal</NavItem>
      <NavItem href={token ? '/my-account' : '/login'} icon={<IconAccount />} active={currentPath === 'my-account' || currentPath === 'login'}>Account</NavItem>
    </G.MobileNav>
  )
}

export default MobileNavbar;
